import { connect } from 'react-redux';

import MapComponent from './component';

import { getDemo } from './selectors';
import { getMarker } from './selectors';


const mapStateToProps = state => ({
  demo: getDemo(state),
  latLng: getMarker(state) 
});

export default connect(mapStateToProps)(MapComponent);


// WEBPACK FOOTER //
// ./src/components/map/index.js